import React from 'react';
import { Link } from 'react-router-dom';

const FocusPalestras = () => {
  const palestras = [
    {
      title: 'Liderança Transformadora',
      description: 'Como desenvolver uma liderança que inspira e transforma equipes.',
      duration: '2-4 horas',
      audience: 'Líderes e Gestores',
      icon: '👑',
      topics: [
        'Estilos de liderança',
        'Comunicação eficaz',
        'Motivação de equipes',
        'Gestão de conflitos'
      ]
    },
    {
      title: 'Inteligência Emocional no Trabalho',
      description: 'Desenvolva suas competências emocionais para melhor performance profissional.',
      duration: '3-6 horas',
      audience: 'Todos os níveis',
      icon: '🧠',
      topics: [
        'Autoconhecimento',
        'Autorregulação',
        'Empatia',
        'Habilidades sociais'
      ]
    },
    {
      title: 'Gestão do Tempo e Produtividade',
      description: 'Técnicas práticas para otimizar seu tempo e aumentar a produtividade.',
      duration: '2-3 horas',
      audience: 'Profissionais em geral',
      icon: '⏰',
      topics: [
        'Matriz de Eisenhower',
        'Técnica Pomodoro',
        'Eliminação de desperdícios',
        'Foco e concentração'
      ]
    },
    {
      title: 'Comunicação Assertiva',
      description: 'Aprenda a se comunicar de forma clara, objetiva e respeitosa.',
      duration: '2-4 horas',
      audience: 'Todos os níveis',
      icon: '💬',
      topics: [
        'Técnicas de comunicação',
        'Escuta ativa',
        'Feedback construtivo',
        'Apresentações eficazes'
      ]
    },
    {
      title: 'Trabalho em Equipe',
      description: 'Fortaleça a colaboração e sinergia entre os membros da equipe.',
      duration: '3-6 horas',
      audience: 'Equipes e times',
      icon: '🤝',
      topics: [
        'Dinâmicas de grupo',
        'Resolução de conflitos',
        'Colaboração efetiva',
        'Construção de confiança'
      ]
    },
    {
      title: 'Inovação e Criatividade',
      description: 'Desperte o potencial criativo e inovador da sua equipe.',
      duration: '2-4 horas',
      audience: 'Equipes criativas',
      icon: '💡',
      topics: [
        'Pensamento criativo',
        'Brainstorming eficaz',
        'Design thinking',
        'Cultura de inovação'
      ]
    },
    {
      title: 'Gestão de Mudanças',
      description: 'Como liderar e adaptar-se às mudanças organizacionais.',
      duration: '3-6 horas',
      audience: 'Líderes e Gestores',
      icon: '🔄',
      topics: [
        'Resistência à mudança',
        'Comunicação da mudança',
        'Engajamento de equipes',
        'Sustentabilidade da mudança'
      ]
    },
    {
      title: 'Vendas e Relacionamento com Clientes',
      description: 'Técnicas avançadas de vendas e fidelização de clientes.',
      duration: '4-8 horas',
      audience: 'Equipes comerciais',
      icon: '📈',
      topics: [
        'Técnicas de vendas',
        'Relacionamento com clientes',
        'Negociação',
        'Pós-venda e fidelização'
      ]
    },
    {
      title: 'Qualidade de Vida no Trabalho',
      description: 'Promova o bem-estar e a qualidade de vida dos colaboradores.',
      duration: '2-3 horas',
      audience: 'Todos os níveis',
      icon: '🌱',
      topics: [
        'Equilíbrio vida-trabalho',
        'Gestão do estresse',
        'Saúde mental',
        'Ambiente saudável'
      ]
    }
  ];

  const eventPhotos = [
    {
      title: 'Palestra sobre Liderança',
      description: 'Evento corporativo na TechCorp',
      icon: '🎤'
    },
    {
      title: 'Workshop de Comunicação',
      description: 'Treinamento interativo',
      icon: '👥'
    },
    {
      title: 'Seminário de Inovação',
      description: 'Evento para 200+ participantes',
      icon: '🏢'
    },
    {
      title: 'Palestra Motivacional',
      description: 'Evento de fim de ano',
      icon: '🎯'
    }
  ];

  const testimonials = [
    {
      name: 'Maria Santos',
      position: 'Diretora de RH',
      company: 'InnovaCorp',
      text: 'A palestra sobre liderança transformou nossa visão de gestão. Resultados incríveis!',
      rating: 5
    },
    {
      name: 'João Silva',
      position: 'Gerente Comercial',
      company: 'VendaMais',
      text: 'O workshop de vendas aumentou nossa performance em 40%. Recomendo fortemente!',
      rating: 5
    },
    {
      name: 'Ana Costa',
      position: 'CEO',
      company: 'StartupTech',
      text: 'Palestra sobre inovação inspirou toda nossa equipe. Conteúdo excepcional!',
      rating: 5
    }
  ];

  return (
    <div className="pt-32"> {/* Espaço para header fixo */}
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-focus-blue to-blue-600 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Focus Palestras
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-blue-100">
              Inspire, motive e transforme sua equipe com palestras impactantes e conteúdo de qualidade.
            </p>
            <Link
              to="/#contato"
              className="bg-focus-orange hover:bg-red-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              Solicite um Orçamento
            </Link>
          </div>
        </div>
      </section>

      {/* Sobre as Palestras */}
      <section className="py-20 bg-focus-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-6">
                Palestras que Transformam
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Nossas palestras são desenvolvidas com base em metodologias comprovadas e 
                experiências práticas do mercado corporativo.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Cada apresentação é personalizada para atender às necessidades específicas 
                da sua empresa, garantindo máximo engajamento e resultados duradouros.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                Nossos palestrantes são especialistas reconhecidos, com vasta experiência 
                em desenvolvimento humano e organizacional.
              </p>
              <div className="grid grid-cols-3 gap-4 text-center">
                <div className="bg-white p-4 rounded-lg shadow">
                  <div className="text-2xl font-bold text-focus-blue">500+</div>
                  <div className="text-sm text-gray-600">Palestras Realizadas</div>
                </div>
                <div className="bg-white p-4 rounded-lg shadow">
                  <div className="text-2xl font-bold text-focus-blue">50+</div>
                  <div className="text-sm text-gray-600">Empresas Atendidas</div>
                </div>
                <div className="bg-white p-4 rounded-lg shadow">
                  <div className="text-2xl font-bold text-focus-blue">98%</div>
                  <div className="text-sm text-gray-600">Satisfação</div>
                </div>
              </div>
            </div>
            <div className="bg-focus-pink rounded-lg p-8">
              <h3 className="text-2xl font-bold text-focus-blue mb-6">Por que escolher nossas palestras?</h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-green-500 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Conteúdo personalizado para sua empresa</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-green-500 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Palestrantes experientes e certificados</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-green-500 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Metodologia interativa e envolvente</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-green-500 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Material de apoio e follow-up</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-green-500 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Flexibilidade de formato e duração</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Temas de Palestras */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-4">
              Nossos Temas de Palestras
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Oferecemos uma ampla variedade de temas para atender às necessidades da sua empresa
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {palestras.map((palestra, index) => (
              <div
                key={index}
                className="bg-focus-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow border border-gray-100"
              >
                <div className="text-center mb-4">
                  <div className="bg-focus-blue w-16 h-16 rounded-full flex items-center justify-center text-2xl mx-auto mb-3">
                    {palestra.icon}
                  </div>
                  <h3 className="text-lg font-semibold text-focus-blue mb-2">
                    {palestra.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    {palestra.description}
                  </p>
                </div>
                
                <div className="mb-4">
                  <h4 className="font-semibold text-focus-blue mb-2 text-sm">Tópicos Abordados:</h4>
                  <ul className="space-y-1">
                    {palestra.topics.map((topic, idx) => (
                      <li key={idx} className="flex items-center text-xs text-gray-600">
                        <svg className="w-3 h-3 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        {topic}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="border-t border-gray-200 pt-3 text-xs text-gray-600">
                  <div className="flex justify-between mb-1">
                    <span><strong>Duração:</strong> {palestra.duration}</span>
                  </div>
                  <div>
                    <span><strong>Público:</strong> {palestra.audience}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Fotos de Eventos */}
      <section className="py-20 bg-focus-pink">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-4">
              Nossos Eventos
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Veja alguns momentos dos nossos eventos e palestras realizadas
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {eventPhotos.map((photo, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
              >
                <div className="bg-focus-blue h-48 flex items-center justify-center text-6xl text-white">
                  {photo.icon}
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-focus-blue mb-1">
                    {photo.title}
                  </h3>
                  <p className="text-gray-600 text-sm">
                    {photo.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Depoimentos */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-4">
              O que Nossos Clientes Dizem
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Feedback de empresas que já contrataram nossas palestras
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-focus-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow"
              >
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-600 italic mb-4">
                  "{testimonial.text}"
                </p>
                <div className="border-t border-gray-200 pt-4">
                  <h4 className="font-semibold text-focus-blue">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.position}</p>
                  <p className="text-xs text-gray-500">{testimonial.company}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-focus-orange text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Pronto para Inspirar sua Equipe?
          </h2>
          <p className="text-xl mb-8 text-red-100 max-w-2xl mx-auto">
            Entre em contato conosco e solicite um orçamento personalizado para sua palestra!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+5511123456789"
              className="bg-white text-focus-orange hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              📞 Solicitar Orçamento
            </a>
            <a
              href="mailto:contato@focus.com.br"
              className="bg-transparent border-2 border-white hover:bg-white hover:text-focus-orange text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              ✉️ Mais Informações
            </a>
          </div>
          <div className="mt-8 text-red-100">
            <p className="text-sm">
              💡 Palestras presenciais e online disponíveis<br/>
              🎯 Conteúdo personalizado para sua empresa<br/>
              📊 Relatório de resultados incluído
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FocusPalestras;